import React, {useContext} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";

const BoShowOccurrenceData = () => {
    const {boData} = useContext(BoShowContext);

    const occurrenceData = boData?.occurrenceData;

    return (
        <>
            <article className={"space-y-4"}>
                <h2 className={"resume-title"}>
                    NATUREZAS
                </h2>

                <section className={"grid grid-cols-3 gap-2"}>
                    {
                        occurrenceData?.reason?.map((item, index) => (
                            <React.Fragment key={"reason-" + index}>
                                <p className={"col-span-2"}>Natureza: <span className={"info"}>{item.nameView ?? ''}</span></p>
                                <p>Grupo: <span className={"info"}>{item.group ?? ''}</span></p>
                            </React.Fragment>
                        ))
                    }
                </section>
            </article>

            <article className={"space-y-4"}>
                <h2 className={"resume-title"}>
                    DADOS DA OCORRÊNCIA
                </h2>

                <section className={"grid grid-cols-3 gap-2"}>
                    <p>D/H do fato: <span className={"info"}>{occurrenceData?.dtFact ?? ''}</span></p>
                    <p>Início: <span className={"info"}>{occurrenceData?.dtPlace ?? ''}</span></p>
                    <p>Término: <span className={"info"}>{occurrenceData?.dtEnd ?? ''}</span></p>
                    <p className={"col-span-3"}>Flagrante: <span className={"info"}>{ occurrenceData?.flagrant != null ? (occurrenceData.flagrant ? 'Sim' : 'Não') : '' }</span></p>
                    <p className={"col-span-3"}>Local: <span className={"info"}>{ occurrenceData?.address?.place ?? ''  }</span></p>
                    <p className={"col-span-2"}>Logradouro: <span className={"info"}>{ occurrenceData?.address?.address ?? ''  }</span></p>
                    <p>Número: <span className={"info"}>{ occurrenceData?.address?.number ?? ''  }</span></p>
                    <p className={"col-span-2"}>Bairro: <span className={"info"}>{ occurrenceData?.address?.neighborhood ?? ''  }</span></p>
                    <p>Cruzamento: <span className={"info"}>{ occurrenceData?.address?.crossroads ?? ''  }</span></p>
                    <p className={"col-span-2"}>Ponto de referência: <span className={"info"}>{ occurrenceData?.address?.referencePoint ?? ''  }</span></p>
                    <p>Município: <span className={"info"}>{ occurrenceData?.address?.city ?? ''  }</span></p>
                    <p className={"col-span-2"}>Complemento: <span className={"info"}>{ occurrenceData?.address?.complement ?? ''  }</span></p>
                    <p>CEP: <span className={"info"}>{ occurrenceData?.address?.zipCode ?? ''  }</span></p>
                    <p className={"col-span-2"}>Latitude: <span className={"info"}>{ occurrenceData?.address?.latitude ?? ''  }</span></p>
                    <p className={"info"}>Longitude: <span className={"info"}>{ occurrenceData?.address?.longitude ?? ''  }</span></p>
                </section>
            </article>
        </>
    );
};

export default BoShowOccurrenceData;